import { motion } from "framer-motion";
import GalleryGrid from "./GalleryGrid"; // Ensure this path is correct

const books = [
  {
    id: 2,
    author: "Sweta Singh",
    title: "When the Shadows Spoke",
    image: "/book2.jpeg",
    amazonLink:
      "https://www.amazon.in/Shadows-Spoke-Remember-Truth-Forgets/dp/B0GD197W8T?ref_=ast_author_dp&th=1&psc=1",
  },
  {
    id: 1,
    author: "Sweta Singh",
    title: "When the Rain Paused",
    image: "/book1.jpeg",
    amazonLink:
      "https://www.amazon.in/When-Rain-Paused-Story-Shadow/dp/B0FJMHNQ3L",
  },
];

function BookCard({ book }) {
  return (
    <motion.div
      key={book.id}
      whileHover={{ y: -8 }}
      className="group cursor-pointer mx-auto"
    >
      <div className="relative overflow-hidden">
        <img
          src={book.image}
          alt={book.title}
          className="w-full max-w-[300px] h-[520px] object-contain"
        />
      </div>
      <div className="mt-6 space-y-2">
        <p className="text-xs tracking-[0.3em] text-[#565449]">{book.author}</p>
        <h3 className="text-xl font-serif text-[#11120D]">{book.title}</h3>
        {book.amazonLink && (
          <a
            href={book.amazonLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#FF9900] hover:bg-[#e68300] transition text-white font-semibold px-6 py-2 rounded mt-3 tracking-wide shadow"
          >
            Buy Now
          </a>
        )}
      </div>
    </motion.div>
  );
}

export default function BooksGrid() {
  return (
    <>
      {/* Top Book */}
      <section className=" px-6 lg:px-20 pt-20 pb-0">
        <div className="grid grid-cols-1 gap-10">
          <BookCard book={books[0]} />
        </div>
      </section>

      {/* Gallery Grid */}
      <GalleryGrid />

      {/* Bottom Book */}
      <section className=" px-6 lg:px-20 pt-0 pb-20">
        <div className="grid grid-cols-1 gap-10">
          <BookCard book={books[1]} />
        </div>
      </section>
    </>
  );
}
